export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./content-string-ref.vue?vue&type=template&id=4b097497"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/string/content-string-ref.vue?vue&type=template&id=4b097497
// module id = rUH2
// module chunks = 0